export { useContactPermissions } from '../_internal/hooks/useContactPermissions';